import { LocalStore } from '@/shared/lib/local-storage';

export const createPersistence = (prefix) => {
  const store = new LocalStore(prefix);

  const createAccessor = () => ({
    get: (key, defaultValue) => store.get(key, defaultValue),
    set: (key, value) => store.set(key, value),
    clear: () => store.clear(),
  });

  const defineMutation = (statePath, storageKey, defaultValue, callback = null) => {
    return (state, value) => {
      const pathSegments = statePath.split('.');
      let target = state;

      for (let i = 0; i < pathSegments.length - 1; i++) {
        target = target[pathSegments[i]];
      }

      const propertyKey = pathSegments[pathSegments.length - 1];
      const oldValue = target[propertyKey];

      target[propertyKey] = value;
      store.set(storageKey, value ?? defaultValue);

      if (typeof callback === 'function') {
        callback({ state, value, oldValue });
      }
    };
  };

  return {
    createAccessor,
    defineMutation,
  };
};
